<section class="auto-search">
  <app-text-input
    [(ngModel)]="autoSearchAddress"
    (ngModelChange)="lookupAddress($event)"
    (inputFocused)="showAddressList = true"
    name="autoSearchAddress"
    label="Search for your address"
  >
    <span label-help class="hint"> e.g. SW1A 2AA or Downing Street </span>
    <i icon-start class="fa-regular fa-search"></i>
  </app-text-input>

  @if (selectedTopLevel && showAddressList) {
    <section class="top-level-selection mt-8">
      <p class="body">
        {{ selectedTopLevel.Description }}
      </p>

      <app-button
        (click)="lookupAddress(autoSearchAddress, undefined, true); selectedTopLevel = undefined"
        class="mt-8 mb-8"
        dataLabel="changeAddress"
        [buttonOptions]="{ variant: 'link-small' }"
      >
        <i class="fa-regular fa-arrow-left fa-lg mr-8"></i>

        <span>Change</span>
      </app-button>
    </section>
  }
  @if (addressFound?.length && showAddressList) {
    <section class="address-list">
      @for (address of addressFound; track address.Id) {
        <button
          type="button"
          class="body"
          [class.selected]="selectedSecondLevel?.Id === address?.Id"
          [class.not-address]="address.Type !== 'Address'"
          (click)="address.Type === 'Address' ? selectAddress(address) : selectTopLevelAddress(address)"
        >
          @if (address.Type === 'Address') {
            <div class="selection"></div>

            {{ address.Text }} {{ address.Description }}
          } @else {
            {{ address.Description }}
            <i class="postcode-arrow fa-regular fa-arrow-right ml-8"></i>
          }
        </button>
      }
    </section>
  } @else if (addressFound?.length === 0 && addressesLoaded && !loadingAddresses) {
    <section class="no-addresses">
      <i class="fa-light fa-circle-exclamation"></i>

      <p class="label">
        <span class="bold">No addresses found</span> - Try a different search, or enter your address manually.
      </p>
    </section>
  }
</section>

@if (!vm.addressPanelExpanded && addressFormError) {
  <section class="top-level-error">
    <i class="fa-light fa-circle-exclamation"></i>
    <p class="body">Enter your address or postcode</p>
  </section>
}

<section class="address-panel mt-16" [class.open]="vm.addressPanelExpanded">
  <section class="header">
    <button
      type="button"
      class="label flex gap-8 body large"
      (click)="addressPanelExpanded.set(!vm.addressPanelExpanded)"
    >
      <span class="link-text"> Enter address manually </span>

      <i
        class="fa-regular"
        [class.fa-chevron-up]="vm.addressPanelExpanded"
        [class.fa-chevron-down]="!vm.addressPanelExpanded"
      ></i>
    </button>
  </section>

  <section #contentPanel [appAnimateOpen]="vm.addressPanelExpanded" class="content">
    <section class="flex-col gap-8 full-width mt-8">
      <app-text-input
        [(ngModel)]="addressValue['addressLine1']"
        (ngModelChange)="onAddressFieldChange()"
        name="addressLine1"
        label="Address line 1"
        placeHolder="Enter your address"
        [tabbable]="vm.addressPanelExpanded"
        [class.autofilled-address]="addressWasSaved()"
      >
        <span label-help class="hint"> Building name or number and street </span>
      </app-text-input>
      @if (addressFormError && addressValue['addressLine1'] === '') {
        <p class="body">
          <i class="fa-light fa-circle-exclamation"></i>
          Enter your address
        </p>
      }
      <app-text-input
        [(ngModel)]="addressValue['addressLine2']"
        (ngModelChange)="onAddressFieldChange()"
        name="addressLine2"
        label="Address line 2 (optional)"
        [tabbable]="vm.addressPanelExpanded"
        [class.autofilled-address]="addressWasSaved()"
      >
        <span label-help class="hint"> Flat, unit, or floor number </span>
      </app-text-input>
      <app-text-input
        [(ngModel)]="addressValue['addressLine3']"
        (ngModelChange)="onAddressFieldChange()"
        name="addressLine3"
        label="Town or city"
        [tabbable]="vm.addressPanelExpanded"
        [class.autofilled-address]="addressWasSaved()"
      />
      <app-text-input
        [(ngModel)]="addressValue['postalCode']"
        (ngModelChange)="onAddressFieldChange()"
        name="postalCode"
        label="Postcode"
        placeHolder="Enter your postcode"
        [tabbable]="vm.addressPanelExpanded"
        [class.autofilled-address]="addressWasSaved()"
      />
      @if (addressFormError && addressValue['postalCode'] === '') {
        <p class="body">
          <i class="fa-light fa-circle-exclamation"></i>
          Enter your postcode
        </p>
      }
    </section>
  </section>

  <app-button
    class="mt-16"
    dataLabel="continue-to-payment"
    [buttonOptions]="{
      fill: false,
    }"
    (onClick)="saveAddress()"
  >
    Continue to payment
    <i class="fa-light fa-arrow-right ml-8"></i>
  </app-button>
</section>
